export default function BadgesSettings() {

    try {

        var Badges = (function(){
            $('[data-toggle="popover"]').popover();
            $('.badge-copy-button').each(function(){
                $(this).on( 'click', function(e){
                    var codeInput = $('#'+$(this).data('target'));
                    codeInput.select();
                    if(document.execCommand("copy")){
                        $(this).popover('show');
                        var button = $(this);
                        setTimeout(function(){
                            button.popover('hide');
                        },1000)
                    }
                    else{
                        // try an iOS workaround
                        var el = codeInput.get(0);
                        var oldCE= el.contentEditable;
                        var oldReadOnly = el.readOnly;
                        var range = document.createRange();
                        el.contentEditable = true;
                        el.readOnly = false;
                        range.selectNodeContents(el);
                        var s = window.getSelection();
                        s.removeAllRanges();
                        s.addRange(range);
                        el.setSelectionRange(0,99999);
                        el.contentEditable = oldCE;
                        el.readOnly = oldReadOnly;
                        if(!document.execCommand('copy')) {
                            modalManager.set(
                                _t("seller_settings_badges:settings.unable-to-copy-label"),
                                '',
                                `<p class="mb-0">${_t("seller_settings_badges:settings.unable-to-copy-text")}</p>`,
                                [
                                    modalManager.basicOkayButtonHTML()
                                ],
                                'modal-sm'
                            );
                        }else{
                            $(this).popover('show');
                            var button = $(this);
                            setTimeout(function(){
                                button.popover('hide');
                            },1000)
                        }

                    }
                });
            });
            $('.elite-pro-row-item').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                var type = $(this).data('badgetype');
                var target = $('#modalToggle-'+type).data('target');
                $(target).modal();
            });
            function handleBadgeScriptResponse(data,color, type, size){
                if(color === "gold"){
                    data = data.replace(/navy/g,'gold');
                }
                if(type === "elitepro"){
                    data = data.replace(/elitepro/g,'verified');
                }
                $('#badge-code-'+type).prop('value', data);
                $('.preview-container').addClass('d-none');
                $('#preview-'+type+'-'+size+'-'+color).removeClass('d-none');

                $('a.email-me-instr').each(function(){
                    $(this).removeClass('d-none');
                    $(this).parent().find('.email-instructions-message').addClass('d-none');
                    $(this).off('click.instructions').one('click.instructions', sendInstructionEmail);
                });
            }
            function sendInstructionEmail(){
                var type = $(this).data('type');
                var color = $('input[name=colorOption-'+type+']:checked').val();
                var size = $('input[name=sizeOption-'+type+']:checked').val();
                var email = $(this).data('email');
                var payload = {
                    email: email,
                    size: size,
                    color: color,
                    type: type === "elitepro" ? "verified" : type,
                };
                var success_message = _t("seller_settings_badges:settings.instructions-sent-success",{"email": email});
                var error_message = _t("seller_settings_badges:settings.instructions-sent-error");
                $.post( '/settings/ajax/badgeemails/', {payload: JSON.stringify(payload)}, function(data){
                    if(data.errors.length === 0){
                        $('a#email-instructions-'+type).addClass('d-none');
                        $('#email-instructions-'+type + ' .email-instructions-message').text(success_message);
                        $('#email-instructions-'+type + ' .email-instructions-message').removeClass('d-none');
                    }
                    else{
                        $('a#email-instructions-'+type).addClass('d-none');
                        $('#email-instructions-'+type + ' .email-instructions-message').text(error_message);
                        $('#email-instructions-'+type + ' .email-instructions-message').removeClass('d-none');
                    }
                }, 'json').fail(function(){
                    $('a#email-instructions-'+type).addClass('d-none');
                    $('#email-instructions-'+type + ' .email-instructions-message').text(error_message);
                    $('#email-instructions-'+type + ' .email-instructions-message').removeClass('d-none');
                });
            }
            $('a.email-me-instr').each(function(){
                $(this).off('click.instructions').one('click.instructions',sendInstructionEmail);
            });
            $('input[type="radio"].badge-size-control').off('change').on('change',function(e){
                var size = $(this).prop('value');
                var type = $(this).data('badgetype');
                var color = $('input[name=colorOption-'+type+']:checked').val();
                $.get({
                        url: '/settings/ajax/badgescripts/'+type+'/'+size,
                        dataType: "text",
                        success: function(data){handleBadgeScriptResponse(data, color, type, size)},
                        error: function(error){
                            // @todo error handling
                            // this will fail to render a preview of any new badge, but it will not cause further ui errors
                            console.error(error);
                        }
                    }
                );
            });
            $('input[type="radio"].badge-color-control').off('change').on('change',function(e){
                var color = $(this).prop('value');
                var type = $(this).data('badgetype');
                var size = $('input[name=sizeOption-'+type+']:checked').val();
                $.get({
                        url: '/settings/ajax/badgescripts/'+type+'/'+size,
                        dataType: "text",
                        success: function(data){
                            handleBadgeScriptResponse(data, color, type, size)},
                        error: function(error){
                            // @todo error handling -- note this is fetching a js/html snippet, not api data
                            // this will fail to render a preview of any new badge, but it will not cause further ui errors
                            console.error(error);
                        }
                    }
                );
            });
            $('.badge-customize-modal').each(function(){
                $(this).off('show.bs.modal').on('show.bs.modal',function(e){
                    var type = $(this).data('badgetype');
                    $('#preview-pane-'+type).on('click',function(e){
                        e.preventDefault();
                        e.stopPropagation();
                    });
                    $('#badge-option-'+ type + '-medium').prop('checked', true);
                    $('#badge-option-'+ type + '-medium').trigger('change');
                })
            })

        });

        Badges();

    } catch (e) {
        console.log(e);
    }

}
